/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![RotateIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA2klEQVR4nO2UOw7CMAyGO3EDNrgPix8dIlviQIQ7cARWVsRjQV25ArCxcIGitCpCpSpNU4RAjeTFUv7P/hM7ir59gHWLpMnEmOGHAHJA1hRJj8EQIhkjyxJYb5kol4I0CRIH0mulMHcAcJU7EWBZxfF09MiTbDqxqLDlWTwH6wJY18H+FzYEibQBGGMGyDIHkkvt++T2npHVujuNAchq3wlXhH0FkOyBdVfOQ16VF8DdqbWrqjP0jB6Q9hb90S+CFoOGrCefDqz3JJPOGgNMtuzUNumkdtn97LkDi6fKCtCtRJ8AAAAASUVORK5CYII=)
 */
export const RotateIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8.3 1.3a1 1 0 0 0 0 1.4l.29.3H6a4 4 0 0 0-4 4v3a1 1 0 1 0 2 0V7c0-1.1.9-2 2-2h2.59l-.3.3a1 1 0 0 0 1.42 1.4l2-2a1 1 0 0 0 0-1.4l-2-2a1 1 0 0 0-1.42 0ZM22 11a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-8Z"
        className={colorClass}
      />
    </svg>
  );
};
